var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.075,
    height: 25.69,
    viewBox: "0 0 32.075 25.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "email",
    d: "M28.845,1.75a3.118,3.118,0,0,1,2.291.939,3.113,3.113,0,0,1,.938,2.29v19.23a3.207,3.207,0,0,1-3.23,3.231H3.23A3.118,3.118,0,0,1,.938,26.5,3.113,3.113,0,0,1,0,24.21V4.98A3.118,3.118,0,0,1,.939,2.688,3.113,3.113,0,0,1,3.23,1.75Zm0,6.46V4.98L16,13.018,3.23,4.98v3.23L16,16.172Z",
    transform: "translate(0 -1.75)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ea3826d8d453ed960c9d61aaf2ae5c92.svg";
export { ForwardRef as ReactComponent };